import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { ReactNode, useContext } from 'react';
import { TimelineContext } from '@/common/components/timeline/TimelineContext.ts';
import { TimelineLine } from '@/common/components/timeline/subcomponents/timeline-line/TimelineLine.tsx';

export interface TimelineItemProps {
  leftContent?: ReactNode;
  icon?: ReactNode;
  rightContent?: ReactNode;
  lineBadge?: ReactNode;
  isLast?: boolean;
  lineComponent?: ReactNode;
}

export const TimelineItem = ({
  leftContent,
  icon,
  rightContent,
  lineBadge,
  isLast,
  lineComponent,
}: TimelineItemProps) => {
  const { leftContentProps } = useContext(TimelineContext);

  return (
    <Stack direction="row">
      <Box width={0} py={1} pr={2} pb={isLast ? 0 : 5} textAlign="right" {...leftContentProps}>
        {leftContent}
      </Box>
      <Stack width={56} alignItems="center">
        {icon}
        {isLast ? null : (
          <>
            {lineComponent ?? <TimelineLine />}
            {lineBadge}
            {lineComponent ?? <TimelineLine />}
          </>
        )}
      </Stack>
      <Box flex={1} pl={2} pb={isLast ? 0 : 5}>
        {rightContent}
      </Box>
    </Stack>
  );
};
